import { render } from "./CurrentFooter.vue?vue&type=template&id=8f84c0ea&scoped=true"
import script from "./CurrentFooter.vue?vue&type=script&lang=js"
export * from "./CurrentFooter.vue?vue&type=script&lang=js"

import "./CurrentFooter.vue?vue&type=style&index=0&id=8f84c0ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f84c0ea"]])

export default __exports__